import { Subject } from 'rxjs';
// const subject = new Subject();

function getToken() {
    let userData = localStorage.getItem("CPToken") || null;
    // //console.log("Getting user details.");
    // //console.log(userData)
    return JSON.parse(userData);
}

function setToken(data) {
    localStorage.setItem('CPToken', JSON.stringify(data));
    // subject.next(true);
}

function isLogin() {
    let data = getToken();
    if (data) {
        return true;
    } else {
        return false;
    }
}

function clearLocalStorage() {
    localStorage.removeItem('CPToken');
    // subject.next(false);
}

export {
    getToken,
    setToken,
    isLogin,
    clearLocalStorage,
    // subject
}